var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmaterialTimerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.082,
    height: 34.207,
    viewBox: "0 0 30.082 34.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-timer-off",
    "data-name": "Icon material-timer-off",
    d: "M28.56,6.825l-2.13,2.13A13.513,13.513,0,0,0,10.575,8.22l2.19,2.19A10.484,10.484,0,0,1,27.09,24.735l2.175,2.175a13.432,13.432,0,0,0-.72-15.825l2.13-2.13ZM22.5,1.5h-9v3h9Zm-6,12.66,3,3V12h-3ZM4.53,6,2.625,7.905l4.125,4.14a13.5,13.5,0,0,0,18.72,18.7l3.75,3.75,1.905-1.9L19.56,21.03ZM18,30A10.5,10.5,0,0,1,8.925,14.22l14.34,14.34A10.3,10.3,0,0,1,18,30Z",
    transform: "translate(-1.918 -1)",
    fill: "#f5062b",
    stroke: "#f5062b",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialTimerOff);
export default __webpack_public_path__ + "static/media/Icon material-timer-off.af5d82510bc695e05a67bac280169b31.svg";
export { ForwardRef as ReactComponent };